import PropTypes from 'prop-types';
import Combobox from './Combobox';
import { useField } from 'formik';

export default function ComboboxField({ label, ...props }) {
  const [field, meta, helpers] = useField(props);

  const { setValue } = helpers;

  return (
    <Combobox
      isValid={!meta.touched || (meta.touched && !meta.error)}
      error={meta.error}
      label={label}
      {...field}
      {...props}
      onChange={(changes) => {
        setValue(changes?.id || changes?.value);

        // try to handle custom onChange though this does NOT return
        // typical React synthetic events
        props?.onChange?.(changes);
      }}
    />
  );
}

ComboboxField.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
};
